import api from './auth.api';

export type SyncRunStatus = 'idle' | 'running' | 'completed' | 'failed';

export interface SyncStatus {
  status: SyncRunStatus;
  syncType: 'subscribers' | 'invoices' | 'full' | null;
  phase: string;
  progress: { current: number; total: number; percent: number };
  startedAt: string | null;
  finishedAt: string | null;
  lastSyncedAt: string | null;
  nextSyncAt: string | null;
  minutesUntilNextSync: number;
  result: Record<string, unknown> | null;
  error: string | null;
  runId: number | null;
}

export const syncApi = {
  getStatus: async (): Promise<SyncStatus> => {
    const response = await api.get<{ success: boolean; data: SyncStatus }>('/sync/status');
    return response.data.data;
  },

  /** Queue background sync (optional manual trigger). */
  queueSync: async (): Promise<SyncStatus & { queued?: boolean; reason?: string }> => {
    const response = await api.post<{
      success: boolean;
      data: SyncStatus & { queued?: boolean; reason?: string };
    }>('/sync/ensure');
    return response.data.data;
  },
};

export default syncApi;
